import axios from "axios";
import { HttpClient, RequestParams } from "../../utils/api/http-client";
import IBaseListingResponse from "../../utils/api/base-listing-response";

import { ACCESS_TOKEN, LANGUAGE_CODE } from "../../utils/helpers/constants";

import {
  ICreateOperationStoreCategories,
  IExportOperationStoreCategoriesExcel,
  IUpdateOperationStoreCategories,
} from "../../models/operation-store-categories/request";
import { IOperationStoreCategories, IOperationStoreCategoriesDetails } from "../../models/operation-store-categories/response";
import { IOperationStoreCategoriesQuery } from "../../models/operation-store-categories/query";

class OperationStoreCategoriesService<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  getAllOperationStoreCategories = (query: IOperationStoreCategoriesQuery, params?: RequestParams) =>
    this.http.request<IBaseListingResponse<IOperationStoreCategories>>({
      path: `/operation-store-categories`,
      method: "GET",
      query,
      ...params,
    });

  getOperationStoreCategories = (id: number, params?: RequestParams) =>
    this.http.request<IOperationStoreCategoriesDetails>({
      path: `/operation-store-categories/${id}`,
      method: "GET",
      ...params,
    });

  createOperationStoreCategories = (data: ICreateOperationStoreCategories, params?: RequestParams) =>
    this.http.request<IOperationStoreCategories>({
      path: "/operation-store-categories",
      method: "POST",
      body: data,
      ...params,
    });

  updateOperationStoreCategories = (id: number, data: IUpdateOperationStoreCategories, params?: RequestParams) =>
    this.http.request<IOperationStoreCategories>({
      path: `/operation-store-categories/${id}`,
      method: "PUT",
      body: data,
      ...params,
    });

  deleteOperationStoreCategories = (id: number, params?: RequestParams) =>
    this.http.request<IOperationStoreCategories>({
      path: `/operation-store-categories/${id}`,
      method: "DELETE",
      ...params,
    });

  exportExcel = (data: IExportOperationStoreCategoriesExcel, query: IOperationStoreCategoriesQuery) =>
    axios.post(` ${process.env.REACT_APP_BASE_API_URL}/operation-store-categories/export`, data, {
      headers: {
        authorization: `Bearer ${
          localStorage.getItem(ACCESS_TOKEN) ||
          sessionStorage.getItem(ACCESS_TOKEN)
        }`,
        "Content-Type": "application/json",
        "accept-language": `${
          localStorage.getItem(LANGUAGE_CODE) ??
          process.env.REACT_APP_DEFAULT_LANGUAGE
        }`,
      },
      params: query,
      responseType: "arraybuffer",
    });
}

export default OperationStoreCategoriesService;